import { withPageAuthRequired, UserProfile } from "@auth0/nextjs-auth0";
import { NextPage } from "next";
import { FC, useEffect } from "react";
import { Layout } from "../../components/Layout";
import { History } from "../../components/mypage/History";
import { fetchPostJSON } from "../../utils/api-helpers";

type MypageProps = {
  user: UserProfile;
};

const HistoryPage: FC<MypageProps> = ({ user }) => {
  return (
    <Layout title="地域・教育魅力化プラットフォーム">
      <History auth0_id={user!.sub!} />
    </Layout>
  );
};

export default withPageAuthRequired(HistoryPage);
